import React from 'react';
import PropTypes from 'prop-types';

import {
  DownloadIcon
} from 'zoomforth_component_lib/external_modern_icons.jsx';


const PresentationTopBar = ({ displayFilename, canDownloadAsset, onDownloadClick }) => (
  <div className="presentation-top-bar">

    <div className="presentation-left">
      <span className="presentation-name">{ displayFilename }</span>
    </div>

    <div className="presentation-right">
      {
        canDownloadAsset &&
          <DownloadIcon
            className="download-btn"
            onClick={onDownloadClick}
          />
      }
    </div>

  </div>
);

PresentationTopBar.propTypes = {
  canDownloadAsset: PropTypes.bool.isRequired,
  displayFilename: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired
};

export default PresentationTopBar;
